var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoritedPinkSvg(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8277 1.94777C20.7355 0.966213 19.334 0.459026 17.9184 0.501213C16.161 0.501213 14.3873 1.22309 13.0902 2.56277L12.1668 3.51293L11.2433 2.56277C9.94491 1.22309 8.17303 0.501213 6.41522 0.501213C4.99959 0.501213 3.59943 0.966682 2.46553 1.94777C-0.447286 4.46918 -0.593068 8.96496 2.03287 11.679L11.0891 21.0399C11.3887 21.3465 11.773 21.5012 12.1621 21.5012C12.5527 21.5012 12.9444 21.3481 13.2407 21.0416L22.2923 11.6807C24.9262 8.96214 24.7809 4.46684 21.8277 1.94777Z",
    fill: "#E25297"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritedPinkSvg);
export default __webpack_public_path__ + "static/media/FavoritedPinkSvg.7ac5f0a32494e43ae6ced5406634abd0.svg";
export { ForwardRef as ReactComponent };